import React, { Component } from 'react';
import Topbar from '../../components/common/Topbar';
import Footer from '../../components/common/Footer';
import Location from '../../components/master/Location';

class LocationPage extends Component {
    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column master-page-layout">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            <Location />

                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }
}

export default LocationPage;